export default __webpack_public_path__ + "static/IllustrationPoseDelete-50b4694b1745093c29f7ae410d27aa64.svg";